import { render, staticRenderFns } from "./PauseButton.vue?vue&type=template&id=0fd3a700&scoped=true"
import script from "./PauseButton.vue?vue&type=script&lang=js"
export * from "./PauseButton.vue?vue&type=script&lang=js"
import style0 from "./PauseButton.vue?vue&type=style&index=0&id=0fd3a700&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd3a700",
  null
  
)

export default component.exports